<p>new-component works!</p>
